const getFullValue = (e: React.ChangeEvent<HTMLInputElement> | any) => {
  const inputValueFull = e.currentTarget.value;
  const inputValueCurrent = e.nativeEvent.data;

  if (inputValueFull.length < 2 && inputValueCurrent === "+") {
    return "+";
  } else {
    return inputValueFull.replace(/\D/g, "");
  }
};

export const cleanPhone = (phone: string) => {
  return "+" + phone.replace(/[^\d]/g, "");
};

export const phoneMaskFormat = (phone: string) => {
  if (!phone) return "";
  
  // Если телефон уже отформатирован правильно, возвращаем как есть
  if (phone.match(/^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/)) {
    return phone;
  }
  
  const phoneWithoutPlus = phone.startsWith('+') ? phone.slice(1) : phone;
  const digitsOnly = phoneWithoutPlus.replace(/\D/g, '');
  
  if (digitsOnly.length < 11) {
    return phone;
  }
  
  // Если первая цифра 8, заменяем на 7
  const firstDigit = digitsOnly[0];
  const normalizedDigits = firstDigit === '8' ? '7' + digitsOnly.slice(1) : digitsOnly;
  
  return `+7 (${normalizedDigits.slice(1, 4)}) ${normalizedDigits.slice(4, 7)}-${normalizedDigits.slice(7, 9)}-${normalizedDigits.slice(9, 11)}`;
};

export const phoneMask = (e: React.ChangeEvent<HTMLInputElement>) => {
  const fullValue = getFullValue(e);
  const firstSimbol = fullValue[0];

  let resultInputValue;

  if (["7", "8", "9"].includes(firstSimbol)) {
    switch (firstSimbol) {
      case "7":
        resultInputValue = "+7";
        break;
      case "8":
        resultInputValue = "+7";
        break;
      case "9":
        resultInputValue = "+7 (9";
    }

    if (fullValue.length > 1) {
      resultInputValue += " (" + fullValue.slice(1, 4);
    }
    if (fullValue.length >= 5) {
      resultInputValue += ") " + fullValue.slice(4, 7);
    }
    if (fullValue.length >= 8) {
      resultInputValue += "-" + fullValue.slice(7, 9);
    }
    if (fullValue.length >= 10) {
      resultInputValue += "-" + fullValue.slice(9, 11);
    }
  } else if (firstSimbol === "+") {
    resultInputValue = "+";
  } else if (!fullValue) {
    resultInputValue = "";
  } else {
    resultInputValue = "+ 7 " + fullValue.substring(0, 16);
  }

  return resultInputValue;
};
